import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=106594bd&scoped=true&"
import script from "./SortableList.vue?vue&type=script&lang=js&"
export * from "./SortableList.vue?vue&type=script&lang=js&"
import style0 from "./SortableList.vue?vue&type=style&index=0&id=106594bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106594bd",
  null
  
)

export default component.exports